const ICON_THEME_MODE = {
  DEFAULT: 'default',
  CUSTOM: 'custom',
  INVERT: 'invert',
};

const ICON_THEME_MODES = [ICON_THEME_MODE.DEFAULT, ICON_THEME_MODE.CUSTOM, ICON_THEME_MODE.INVERT];
const DEFAULT_ICON_THEME_COLOR = '#2554C7';

function normalizeHexColor(value) {
  const compact = String(value || '')
    .trim()
    .replace(/\s/g, '')
    .toUpperCase();
  if (!compact) return null;
  const withHash = compact.startsWith('#') ? compact : `#${compact}`;
  return /^#[0-9A-F]{6}$/.test(withHash) ? withHash : null;
}

function mixWithWhite(hex, ratio) {
  const normalized = normalizeHexColor(hex);
  if (!normalized) return null;

  const clean = normalized.slice(1);
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  const mix = (channel) =>
    Math.round(channel + (255 - channel) * ratio)
      .toString(16)
      .padStart(2, '0')
      .toUpperCase();

  return `#${mix(r)}${mix(g)}${mix(b)}`;
}

export function getIconThemeTileStyle(mode, color) {
  const hex = normalizeHexColor(color) || DEFAULT_ICON_THEME_COLOR;
  if (mode === ICON_THEME_MODE.CUSTOM) {
    return { background: mixWithWhite(hex, 0.88), color: hex };
  }
  if (mode === ICON_THEME_MODE.INVERT) {
    return { background: hex, color: mixWithWhite(hex, 0.62) };
  }
  return null;
}

export function getDetailAccentStyle(mode, color) {
  if (mode !== ICON_THEME_MODE.CUSTOM && mode !== ICON_THEME_MODE.INVERT) return null;
  const hex = normalizeHexColor(color) || DEFAULT_ICON_THEME_COLOR;
  return {
    '--blue': hex,
    '--blue-dark': hex,
    '--soft': mixWithWhite(hex, 0.86),
    '--table-ink': hex,
  };
}

export function normalizePackageIconTheme(source) {
  const allowed = new Set(ICON_THEME_MODES);
  const mode = source?.temaIconos || source?.mode;
  const color =
    normalizeHexColor(source?.colorTemaIconos || source?.color) || DEFAULT_ICON_THEME_COLOR;

  return {
    mode: allowed.has(mode) ? mode : ICON_THEME_MODE.DEFAULT,
    color,
  };
}

export function isExternalSupplierPackage(pkg, viewingApplicationId, providerType) {
  if (providerType === 'PROVEEDOR_REGIONAL') return true;
  if (pkg?.userId != null && pkg.userId !== '') return true;
  const pkgAppId = pkg?.applicationId;
  if (pkgAppId != null && viewingApplicationId && Number(pkgAppId) !== Number(viewingApplicationId)) {
    return true;
  }
  return false;
}

export function resolvePackageIconThemeForViewer({
  temaIconos,
  colorTemaIconos,
  isSupplierPackage,
  agencyBrandColor,
}) {
  if (isSupplierPackage) {
    const brand = normalizeHexColor(agencyBrandColor) || DEFAULT_ICON_THEME_COLOR;
    return { mode: ICON_THEME_MODE.CUSTOM, color: brand };
  }
  return normalizePackageIconTheme({ temaIconos, colorTemaIconos });
}
